/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Api_Title3Inputs */

const en_svc_backend_development_api_title3 = /** @type {(inputs: Svc_Backend_Development_Api_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REST & GraphQL design`)
};

const ar_svc_backend_development_api_title3 = /** @type {(inputs: Svc_Backend_Development_Api_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصميم REST و GraphQL`)
};

const bn_svc_backend_development_api_title3 = /** @type {(inputs: Svc_Backend_Development_Api_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REST ও GraphQL ডিজাইন`)
};

const de_svc_backend_development_api_title3 = /** @type {(inputs: Svc_Backend_Development_Api_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REST- und GraphQL-Design`)
};

const es_svc_backend_development_api_title3 = /** @type {(inputs: Svc_Backend_Development_Api_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseño REST y GraphQL`)
};

const fr_svc_backend_development_api_title3 = /** @type {(inputs: Svc_Backend_Development_Api_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conception REST et GraphQL`)
};

const pt_svc_backend_development_api_title3 = /** @type {(inputs: Svc_Backend_Development_Api_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design REST e GraphQL`)
};

const zh_svc_backend_development_api_title3 = /** @type {(inputs: Svc_Backend_Development_Api_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REST 和 GraphQL 设计`)
};

const tr_svc_backend_development_api_title3 = /** @type {(inputs: Svc_Backend_Development_Api_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REST ve GraphQL tasarımı`)
};

const ru_svc_backend_development_api_title3 = /** @type {(inputs: Svc_Backend_Development_Api_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дизайн REST и GraphQL`)
};

const pl_svc_backend_development_api_title3 = /** @type {(inputs: Svc_Backend_Development_Api_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt REST i GraphQL`)
};

/**
* | output |
* | --- |
* | "REST & GraphQL design" |
*
* @param {Svc_Backend_Development_Api_Title3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_api_title3 = /** @type {((inputs?: Svc_Backend_Development_Api_Title3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Api_Title3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_api_title3(inputs)
	if (locale === "bn") return bn_svc_backend_development_api_title3(inputs)
	if (locale === "de") return de_svc_backend_development_api_title3(inputs)
	if (locale === "es") return es_svc_backend_development_api_title3(inputs)
	if (locale === "fr") return fr_svc_backend_development_api_title3(inputs)
	if (locale === "pt") return pt_svc_backend_development_api_title3(inputs)
	if (locale === "zh") return zh_svc_backend_development_api_title3(inputs)
	if (locale === "tr") return tr_svc_backend_development_api_title3(inputs)
	if (locale === "ru") return ru_svc_backend_development_api_title3(inputs)
	if (locale === "pl") return pl_svc_backend_development_api_title3(inputs)
	return en_svc_backend_development_api_title3(inputs)
});
export { svc_backend_development_api_title3 as "svc_backend-development_API_title" }